import APIClient from './client'
import { camelizeKeys, decamelizeKeys } from 'humps'

const getLeadsExports = (connectionId) => {
  return APIClient().get(`/v1/connections/${connectionId}/leads_exports`)
    .then(response => camelizeKeys(response.data))
}

const getLeadsExport = (connectionId, id) => {
  return APIClient().get(`/v1/connections/${connectionId}/leads_exports/${id}`)
    .then(response => camelizeKeys(response.data))
}

const createLeadsExport = ({ connectionId, payload }) => {
  return APIClient().post(`/v1/connections/${connectionId}/leads_exports`, { leads_export: decamelizeKeys(payload) })
    .then(response => camelizeKeys(response.data))
}

const downloadLeadsExport = (connectionId, id) => {
  return APIClient().get(`/v1/connections/${connectionId}/leads_exports/${id}/download`, { responseType: 'blob' })
}

const leadsExportsAPIs = {
  getLeadsExports,
  getLeadsExport,
  createLeadsExport,
  downloadLeadsExport,
}

export default leadsExportsAPIs
